<app-header></app-header>
<div class="mainwrapper">
  <div class="new-container">
    <div class="library-header wrapper">
      <div class="upper-header-section">
        <div class="header-title">
          <div class="astro-head">
            <div class="astro-iko">
              <svg class="astro-icon" viewBox="0 0 48 48" fill="none">
                <ellipse
                  cx="24"
                  cy="24"
                  rx="20"
                  ry="8"
                  stroke="#da8207"
                  stroke-width="1.5"
                  fill="none"
                  transform="rotate(0 24 24)"
                />
                <ellipse
                  cx="24"
                  cy="24"
                  rx="20"
                  ry="8"
                  stroke="#da8207"
                  stroke-width="1.5"
                  fill="none"
                  transform="rotate(60 24 24)"
                  opacity="0.7"
                />
                <ellipse
                  cx="24"
                  cy="24"
                  rx="20"
                  ry="8"
                  stroke="#da8207"
                  stroke-width="1.5"
                  fill="none"
                  transform="rotate(120 24 24)"
                  opacity="0.5"
                />
                <circle cx="24" cy="24" r="4" fill="#da8207" />
                <circle cx="44" cy="24" r="2" fill="#da8207" opacity="0.8" />
                <circle cx="24" cy="4" r="2" fill="#da8207" opacity="0.9" />
                <circle cx="4" cy="24" r="2" fill="#da8207" opacity="0.6" />
              </svg>
            </div>
            <h2 class="header-new">Ingress Charts Library</h2>
          </div>
          <p>Manage and analyze seasonal ingress charts.</p>
        </div>
        <div class="action-controls-header-group">
          <div class="action-controls-group">
            <p class="sort">Sort By :</p>
            <div class="custom-selection">
              <select
                [(ngModel)]="sortOption"
                (ngModelChange)="onSortChange($event)"
              >
                <option *ngFor="let opt of sortOptions" [ngValue]="opt.value">
                  {{ opt.label }}
                </option>
              </select>
            </div>

            <!-- *ngIf="totalChartsCount > initialChartsToShow" -->
            <button class="view-all-link" (click)="toggleCharts()">
              <i class="fa fa-eye"></i>
              View {{ showPast ? "Upcoming" : "Past" }} Charts
            </button>
          </div>
          <div class="header-count">
            <h2>
              Total Number Of
              {{ showPast ? "Past" : "Upcoming" }} Charts :
            </h2>
            <h2>{{ chartsCount }}</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="sticky-header">
      <div class="loader-div">
        <mat-progress-bar
          *ngIf="isLoading"
          mode="indeterminate"
          color="primary"
          class="chart-progress-bar"
        >
        </mat-progress-bar>
      </div>

      <div class="addEditPageWrapper">
        <div class="addEditForm">
          <form>
            <div class="first-form-div">
              <div class="form_field_wrapper">
                <mat-form-field>
                  <mat-label>Start Date</mat-label>
                  <input
                    matInput
                    [matDatepicker]="startDatePicker"
                    [(ngModel)]="filters.startDate"
                    name="startDate"
                    (dateChange)="applyFilters()"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="startDatePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #startDatePicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="form_field_wrapper">
                <mat-form-field>
                  <mat-label>End Date</mat-label>
                  <input
                    matInput
                    [matDatepicker]="endDatePicker"
                    [(ngModel)]="filters.endDate"
                    name="endDate"
                    (dateChange)="applyFilters()"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="endDatePicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #endDatePicker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div class="secoend-form-div">
              <div class="form_field_wrapper">
                <mat-form-field appearance="outline">
                  <mat-label>Location</mat-label>

                  <div class="autocomplete-input">
                    <div class="input-fields">
                      <!-- FIX: use ngModel with name -->
                      <input
                        matInput
                        type="text"
                        class="make-input"
                        [(ngModel)]="cityDisplay"
                        name="city"
                        (input)="onCityInput($any($event.target).value)"
                        (focus)="openCityDropdown()"
                        (keydown)="onCityKeydown($event)"
                        placeholder="Type city, state, country"
                        autocomplete="off"
                        [attr.aria-expanded]="
                          showCityDropdown ? 'true' : 'false'
                        "
                        aria-autocomplete="list"
                      />

                      <!-- Clear button -->
                      <button
                        *ngIf="cityDisplay"
                        type="button"
                        class="clear-btn"
                        (click)="clearCity($event)"
                        aria-label="Clear city"
                      >
                        ×
                      </button>
                    </div>

                    <!-- Loader -->
                    <mat-progress-bar
                      *ngIf="cityLoading"
                      mode="indeterminate"
                      color="primary"
                      class="city-progress-bar"
                    >
                    </mat-progress-bar>
                  </div>

                  <!-- Dropdown -->
                  <div class="single-select-dropdown" *ngIf="showCityDropdown">
                    <div class="dropdown-content">
                      <!-- Empty state -->
                      <div
                        class="empty-result"
                        *ngIf="
                          !cityLoading &&
                          cityResults.length === 0 &&
                          citySearchText.length >= MIN_CITY_CHARS
                        "
                      >
                        No matches
                      </div>

                      <!-- Results -->
                      <div
                        *ngFor="
                          let option of cityResults;
                          let i = index;
                          trackBy: trackByCity
                        "
                        class="dropdown-option"
                        [class.active]="i === cityActiveIndex"
                        (click)="selectCity(option)"
                      >
                        <span>{{ option.val }}</span>
                      </div>
                    </div>
                  </div>
                </mat-form-field>
              </div>

              <div class="form_field_wrapper">
                <mat-form-field
                  class="keyword-search-container"
                  appearance="outline"
                >
                  <mat-label>Title Search</mat-label>
                  <div class="autocomplete-input">
                    <div class="input-fields">
                      <!-- FIX: use ngModel with name -->
                      <input
                        matInput
                        type="text"
                        class="make-input"
                        [(ngModel)]="searchTitleDisplay"
                        name="keywordSearch"
                        (input)="onTitleInput($any($event.target).value)"
                        (focus)="openTitleDropdown()"
                        (keydown)="onTitleKeydown($event)"
                        placeholder="Type chart title"
                        autocomplete="off"
                        [attr.aria-expanded]="
                          showTitleDropdown ? 'true' : 'false'
                        "
                        aria-autocomplete="list"
                      />

                      <!-- Clear button -->
                      <button
                        *ngIf="searchTitleDisplay"
                        type="button"
                        class="clear-btn"
                        (click)="clearTitle($event)"
                        aria-label="Clear title"
                      >
                        ×
                      </button>
                    </div>

                    <!-- Loading indicator -->
                    <mat-progress-bar
                      *ngIf="titleLoading"
                      mode="indeterminate"
                      color="primary"
                      class="city-progress-bar"
                    >
                    </mat-progress-bar>
                  </div>

                  <!-- Custom dropdown -->
                  <div class="single-select-dropdown" *ngIf="showTitleDropdown">
                    <div class="dropdown-content">
                      <!-- Empty state -->
                      <div
                        class="empty-result"
                        *ngIf="
                          !titleLoading &&
                          titleResults.length === 0 &&
                          (searchTitleText || '').length >= MIN_TITLE_CHARS
                        "
                      >
                        No matches
                      </div>

                      <!-- Results -->
                      <div
                        *ngFor="
                          let option of titleResults;
                          let i = index;
                          trackBy: trackByTitle
                        "
                        class="dropdown-option"
                        [class.active]="i === titleActiveIndex"
                        (click)="selectTitle(option)"
                      >
                        <span>{{ option.val }}</span>
                      </div>
                    </div>
                  </div>
                </mat-form-field>
              </div>
            </div>
            <!-- Third Row Search -->
            <div class="secoend-form-div">
              <div class="form_field_wrapper">
                <mat-form-field appearance="outline">
                  <mat-label>Author Search</mat-label>
                  <div class="autocomplete-input">
                    <div class="input-fields">
                      <!-- FIX: use ngModel with name -->
                      <input
                        matInput
                        type="text"
                        class="make-input"
                        [(ngModel)]="authorDisplay"
                        name="  author"
                        (input)="onauthorInput($any($event.target).value)"
                        (focus)="openauthorDropdown()"
                        (keydown)="onauthorKeydown($event)"
                        placeholder="Search By Author Name Or Email"
                        autocomplete="off"
                        [attr.aria-expanded]="
                          showauthorDropdown ? 'true' : 'false'
                        "
                        aria-autocomplete="list"
                      />

                      <!-- Clear button -->
                      <button
                        *ngIf="authorDisplay"
                        type="button"
                        class="clear-btn"
                        (click)="clearauthor($event)"
                        aria-label="Clear city"
                      >
                        ×
                      </button>
                    </div>

                    <!-- Loader -->
                    <mat-progress-bar
                      *ngIf="authorLoading"
                      mode="indeterminate"
                      color="primary"
                      class="city-progress-bar"
                    >
                    </mat-progress-bar>
                  </div>

                  <!-- Dropdown -->
                  <div
                    class="single-select-dropdown"
                    *ngIf="showauthorDropdown"
                  >
                    <div class="dropdown-content">
                      <!-- Empty state -->
                      <div
                        class="empty-result"
                        *ngIf="
                          !authorLoading &&
                          authorResults.length === 0 &&
                          authorSearchText.length >= MIN_CITY_CHARS
                        "
                      >
                        No matches
                      </div>

                      <!-- Results -->
                      <div
                        *ngFor="
                          let option of authorResults;
                          let i = index;
                          trackBy: trackByAuthor
                        "
                        class="dropdown-option"
                        [class.active]="i === authorActiveIndex"
                        (click)="selectauthor(option)"
                      >
                        <span>{{ option.key }}</span>
                      </div>
                    </div>
                  </div>
                </mat-form-field>
              </div>

              <div class="form_field_wrapper" *ngIf="isSectorSearch">
                <mat-form-field
                  class="keyword-search-container"
                  appearance="outline"
                >
                  <mat-label>Focus Sector Search</mat-label>
                  <mat-select
                    multiple
                    [(value)]="selectedSearchSectors"
                    (selectionChange)="onSectorChange($event)"
                  >
                    <mat-option
                      *ngFor="let sector of sectorOptions"
                      [value]="sector.val"
                    >
                      {{ sector.key }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </form>
          <div class="error-msg" *ngIf="searchError">
            <p>
              *Invalid filter combination. Please search by
              <strong>Title</strong> OR by <strong>Location</strong> and/or
              <strong>Date</strong>.
            </p>
          </div>

          <div class="action-row">
            <button
              type="button"
              class="round-btn"
              (click)="onSearch()"
              [disabled]="isLoading"
              matTooltip="Search"
              matTooltipPosition="below"
            >
              <mat-icon>search</mat-icon>
              <span class="sr-only">Search</span>
            </button>

            <button
              type="button"
              class="round-btn"
              (click)="onReset()"
              [disabled]="isLoading"
              matTooltip="Refresh"
              matTooltipPosition="below"
            >
              <mat-icon>refresh</mat-icon>
              <span class="sr-only">Reset</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <main class="content-area">
      <div class="charts-grid">
        <div *ngFor="let chart of allIngressData" class="card">
          <div>
            <div class="card-header">
              <div class="card-type">
                <span>{{ chart.ingressType }} Season</span>
              </div>
              <mat-slide-toggle
                [checked]="chart.is_social_advo"
                (click)="$event.stopPropagation()"
                (change)="onToggleSocialAdvo($event.checked, chart)"
                class="social-advo-text"
              >
                Social Advo
              </mat-slide-toggle>
            </div>
            <h2 class="card-title">{{ chart.title }}</h2>
            <div class="chart-des">
              {{ chart.shortDescription }}
            </div>
            <div class="chart-sector-header" *ngIf="chart.sector_focus?.length">
              This Chart Focused On :
            </div>
            <div class="chart-sectors" *ngIf="chart.sector_focus?.length">
              <!-- Show first 2 -->
              <span
                class="sector"
                *ngFor="
                  let sector of chart.sector_focus | slice : 0 : 2;
                  let i = index
                "
              >
                {{ sector
                }}<span *ngIf="i < 1 && chart.sector_focus.length > 2">, </span>
              </span>

              <!-- +X other -->
              <span
                *ngIf="chart.sector_focus.length > 2"
                class="toggle"
                (click)="openPopover(chart, $event)"
              >
                + {{ chart.sector_focus.length - 2 }} other
              </span>
            </div>
            <div class="separator"></div>

            <div class="chart-event">
              <label>Event Time</label>
              <span>{{ chart.eventTimePeriod }}</span>
            </div>
            <div class="chart-period">
              <label>Period</label>
              <span>{{ chart.period }}</span>
            </div>
            <div class="chart-period">
              <label>Author Name</label>
              <span>{{ chart.name }}</span>
            </div>
            <div class="chart-period">
              <label>Author Email</label>
              <span>{{ chart.email }}</span>
            </div>
            <div class="chart-period">
              <label>Created On:</label>
              <span>{{ getFormattedDate(chart.createdAt) }}</span>
            </div>
          </div>
          <a (click)="registerClick(chart._id)" class="card-button"
            >View Analysis</a
          >
        </div>
        <!-- ✅ Popover outside the chart card -->
        <div
          class="popover"
          *ngIf="activeChart"
          [style.top.px]="popoverPosition.top"
          [style.left.px]="popoverPosition.left"
          (click)="$event.stopPropagation()"
        >
          <div class="popover-content">
            <div class="popover-header">Others:</div>
            <div
              class="sector"
              *ngFor="let sector of activeChart.sector_focus | slice : 2"
            >
              {{ sector }}
            </div>
            <div
              class="toggle"
              (click)="closePopover(activeChart); $event.stopPropagation()"
            >
              Show Less
            </div>
          </div>
        </div>
      </div>
      <div
        class="no-results-container"
        *ngIf="!isLoading && allIngressData.length === 0"
      >
        <h3>No Charts Found</h3>
        <p>Try adjusting your filters to find what you're looking for.</p>
      </div>

      <div #sentinel class="intersection-sentinel" aria-hidden="true"></div>
    </main>
    <div class="loader-class" *ngIf="isLoading">
      <div class="skeleton-loader">
        <div class="skeleton-grid">
          <div class="skeleton-card" *ngFor="let item of [1, 2, 3]">
            <div class="skeleton-header">
              <div class="skeleton-icon"></div>
              <div class="skeleton-type"></div>
            </div>
            <div class="scaleton-middle">
              <div class="skeleton-title"></div>
              <div class="skeleton-description"></div>
              <div class="skeleton-description short"></div>
            </div>
            <div class="skeleton-time-periods">
              <div class="skeleton-time-period">
                <div class="skeleton-label"></div>
                <div class="skeleton-value"></div>
              </div>
              <div class="skeleton-time-period">
                <div class="skeleton-label"></div>
                <div class="skeleton-value"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
